import { Capacitor } from '@capacitor/core';
import { Language } from '../store/languageStore';

/**
 * iOS WKWebView sometimes fails to decode certain WebP variants (`makeImagePlus` / err=-50).
 * PNG fallbacks are generated next to the WebP assets in `public/`.
 */
export function getLogoFormatExtension(): 'webp' | 'png' {
  return Capacitor.getPlatform() === 'ios' ? 'png' : 'webp';
}

export function getLogoPath(language: Language): string {
  const ext = getLogoFormatExtension();
  return language === 'he' ? `/logo.${ext}` : `/logo-english.${ext}`;
}

